module.exports = __webpack_public_path__ + "img/banner.c3604d5a.png";